module.exports = __webpack_public_path__ + "img/crop_info_back_feet.fb4338b9.png";